import { useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ConsentGate() {
  const { user, checkAuth } = useAuth();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  if (!user || user.consent_accepted) return null;

  const agree = async () => {
    if (!checked) return;
    setSaving(true);
    try {
      await api.post("/auth/consent");
      await checkAuth();
    } catch {
      toast.error("Couldn't record your consent. Please try again.");
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-surface/90 backdrop-blur-sm flex items-center justify-center p-4" data-testid="consent-gate">
      <div className="max-w-md w-full rounded-2xl border border-line bg-surface p-7 af-fade-up">
        <div className="w-12 h-12 rounded-xl bg-brand-soft border border-brand/30 flex items-center justify-center mb-4">
          <ShieldCheck className="w-6 h-6 text-brand" />
        </div>
        <h2 className="font-display text-xl font-bold">Before you begin</h2>
        <p className="text-sm text-body mt-2 leading-relaxed">
          To use GetInterviewed, please confirm you've read and agree to how we handle your data.
        </p>

        <label className="flex items-start gap-3 mt-5 rounded-lg border border-line bg-canvas p-4 cursor-pointer">
          <input
            data-testid="consent-checkbox"
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5 accent-brand w-4 h-4"
          />
          <span className="text-sm text-ink leading-relaxed">
            I have read and agree to the{" "}
            <a href="/terms" target="_blank" rel="noreferrer" className="text-brand hover:underline">Terms of Service</a>,{" "}
            <a href="/privacy" target="_blank" rel="noreferrer" className="text-brand hover:underline">Privacy Policy</a>{" "}
            and{" "}
            <a href="/pdpa" target="_blank" rel="noreferrer" className="text-brand hover:underline">PDPA Statement</a>, and consent to the processing of my personal data as described.
          </span>
        </label>

        <button
          data-testid="consent-agree-button"
          onClick={agree}
          disabled={!checked || saving}
          className="mt-5 w-full py-2.5 rounded-full bg-brand text-onbrand font-semibold hover:bg-brand-hover transition-colors duration-200 disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Agree & continue
        </button>
      </div>
    </div>
  );
}
